module.exports = __webpack_public_path__ + "static/media/luminatouch-4.b7b374fa.jpg";